import React, { Component } from 'react';

class About extends Component {
    constructor(props) {
        // Required step: always call the parent class' constructor
        super(props);

        // Set the state directly. Use props if necessary.
        this.state = {
            totalDownload: 0,
        }
    }

    componentDidMount() {
    }

  render() {

    if(this.props.data){
      var firstName = this.props.data.firstName;
      var lastName = this.props.data.lastName;
      var profilepic= "images/"+this.props.data.image;
      var qr = "images/"+this.props.data.qr;
      var city = this.props.data.address.city;
      var country = this.props.data.address.country
    }


    return (
      <section id="about">

      <div className="row">
         <div className="column">
            <img className="profile-pic"  src={profilepic} alt="Michael" />
         </div>
          <div className="column">
              <a href="https://t.me/kuropatkin" target="_blank"><img className="qr-pic" href="https://t.me/kuropatkin" src={qr} alt="qr-code" /></a>
              <p className="qr-desc">(clickable)</p>
          </div>
         <div className="eight columns main-col">
            <div className="row">
               <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
						   <span>{firstName} {lastName}</span><br />
						   <span>{country}
                   </span><br />
					   </p>
               </div>
               {/*<div className="columns download">*/}
               {/*       <a className="smoothscroll button" href="#contact">Resume request</a>*/}
               {/*</div>*/}
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js